import { render, staticRenderFns } from "./CustomOperations.vue?vue&type=template&id=2e4476cf&scoped=true"
import script from "./CustomOperations.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomOperations.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CustomOperations.vue?vue&type=style&index=0&id=2e4476cf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4476cf",
  null
  
)

export default component.exports